module.exports = __webpack_public_path__ + "img/icon_07.ecca557e.png";